import { TradeInFlowType } from '@allesauto/utils/consts';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/store/redux';

export type TradeInUIState = {
  identificationTabKey: number;
  lastTradeInFlow: {
    type: TradeInFlowType | undefined;
    carId?: string;
  };
};

const initialState: TradeInUIState = {
  identificationTabKey: 0,
  lastTradeInFlow: {
    type: undefined,
    carId: undefined,
  },
};

const slice = createSlice({
  name: 'tradein/ui',
  initialState,
  reducers: {
    setIdentificationTabKey(state, action: PayloadAction<number>) {
      return {
        ...state,
        identificationTabKey: action.payload,
      };
    },
    setLastTradeInFlow(
      state,
      action: PayloadAction<{ type: TradeInFlowType; value?: string }>
    ) {
      return {
        ...state,
        lastTradeInFlow: {
          type: action.payload.type,
          carId: action.payload.value,
        },
      };
    },
  },
});

export const { setIdentificationTabKey, setLastTradeInFlow } = slice.actions;

export const getTradeInUIState = (state: RootState): TradeInUIState =>
  state.pages.tradeIn.ui;

export default slice.reducer;
